import builder from '../builder';
import Bulb1Alternate from '../../streamline-icons/bold/bulb-1-alternate.svg';

export default builder('IconBulb1AlternateBold', Bulb1Alternate);
